var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reviews"},[_c('div',{staticClass:"elfsight-app-8512f748-0250-4a0e-ba2a-85bdb06bb32c",attrs:{"data-elfsight-app-lazy":""}})])}]

export { render, staticRenderFns }